var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.93,
    height: 34.93,
    viewBox: "0 0 34.93 34.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter-x-seeklogo.com-4",
    transform: "translate(-352.95 -129.27)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_660",
    "data-name": "Ellipse 660",
    cx: 17.465,
    cy: 17.465,
    r: 17.465,
    transform: "translate(352.95 129.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(361.95 138.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    d: "M483.982,356.79l6.73,9L483.94,373.1h1.524l5.929-6.406,4.791,6.406h5.187l-7.109-9.5,6.3-6.81h-1.524l-5.46,5.9-4.412-5.9Zm2.242,1.123h2.383l10.523,14.069h-2.383Z",
    transform: "translate(-483.94 -356.79)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.bf0fabb0640aba365c96b41bf0e967a6.svg";
export { ForwardRef as ReactComponent };